var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLoaderBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "512px",
    height: "512px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 255.8,
    cy: 373.3,
    r: 34.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.8,5.8C117.7,5.8,5.4,118.1,5.4,256.2c0,138.1,112.3,250.4,250.4,250.4s250.4-112.3,250.4-250.4 C506.2,118.1,393.9,5.8,255.8,5.8z M255.8,105c18.9,0,34.1,15.3,34.1,34.1c0,18.9-15.3,34.1-34.1,34.1s-34.1-15.3-34.1-34.1 C221.6,120.3,236.9,105,255.8,105z M255.8,485.4c-63.3,0-114.6-51.3-114.6-114.6s51.3-114.6,114.6-114.6s114.6-51.3,114.6-114.6 c0-61.3-48.2-111.4-108.7-114.5C385.5,30.3,485,131.6,485,256.2C485,382.8,382.4,485.4,255.8,485.4z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoaderBlack);
export default __webpack_public_path__ + "static/media/loader_black.64a0d99996b5633be58bdc09c3dd85ec.svg";
export { ForwardRef as ReactComponent };